import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'qpx-preview-toolbar',
    templateUrl: './preview-toolbar.html',
    styleUrl: './preview-toolbar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        role: 'toolbar',
        '[attr.aria-label]': 'ariaLabel()',
    },
})
export class PreviewToolbar {
    //#region Inputs
    public readonly ariaLabel = input.required<string>();
    //#endregion
}
